import _extends from "@babel/runtime/helpers/extends";
import { useEffect } from 'react';
import { StateEffect, Annotation } from '@codemirror/state';
import { getDefaultExtensions } from '@uiw/react-codemirror';
import { EditorView } from '@codemirror/view';
import { useStore } from './store';
var External = Annotation.define();
export var Modified = props => {
  var {
    extensions = [],
    onChange
  } = props;
  var {
    modified,
    view,
    dispatch
  } = useStore();
  var defaultExtensions = getDefaultExtensions();
  var updateListener = EditorView.updateListener.of(vu => {
    if (vu.docChanged && typeof onChange === 'function' &&
    // Fix echoing of the remote changes:
    // If transaction is market as remote we don't have to call `onChange` handler again
    !vu.transactions.some(tr => tr.annotation(External))) {
      var doc = vu.state.doc;
      var _value = doc.toString();
      onChange(_value, vu);
    }
  });
  var extensionsData = [updateListener, ...defaultExtensions, ...extensions];
  var data = {
    extensions: [...extensionsData]
  };
  useEffect(() => {
    if ((modified == null ? void 0 : modified.doc) !== props.value && view) {
      data.doc = props.value;
      dispatch({
        modified: _extends({}, modified, data)
      });
      var modifiedDoc = view == null ? void 0 : view.b.state.doc.toString();
      if (modifiedDoc !== props.value) {
        view.b.dispatch({
          changes: {
            from: 0,
            to: (modifiedDoc || '').length,
            insert: props.value || ''
          },
          effects: StateEffect.appendConfig.of([...extensionsData]),
          annotations: [External.of(true)]
        });
      }
    }
    if ((modified == null ? void 0 : modified.selection) !== props.selection) {
      data.selection = props.selection;
      dispatch({
        modified: _extends({}, modified, data)
      });
    }
  }, [props.value, extensions, props.selection, view]);
  return null;
};
Modified.displayName = 'CodeMirrorMerge.Modified';